module.exports = __webpack_public_path__ + "img/thai.e620719e.jpg";